export default {
  title: 'Select {type}',
  uploadImage: 'Upload Image',
  uploadVideo: 'Upload Video',
  selectImage: 'Select Image',
  selectVideo: 'Select Video',
  maxCountTip: 'You can select up to {count} materials',
};
